module.exports = __webpack_public_path__ + "img/watage_res_16.268bde12.gif";